import { db } from '../../config/firebaseconfig'
import forOwn from 'mout/object/forOwn'

export default function assignTeacherToStudent (record, student) {

    const studentRef = db.collection('students').doc(student.id)
    const teacherKey = `teachers.${record.teacher}`
    let status = false

    return db.collection('educators').doc(record.teacher).get()
      .then(doc => {
        forOwn(doc.get('classes'), (val, key) => {
          if (val) {
            db.collection('classes').doc(key).get().then(doc => {
              forOwn(doc.get('students'), (stdData, stdKey) => {
                if (stdKey === student.id) {
                  if (stdData) { status = true }
                }
              })
            })
            .then(() => { 
              return studentRef.update({ [teacherKey]: status });
            })
            .catch(err => console.log(err))
          }
        })
      })
      .catch(err => {
        console.log('Error getting document', err);
      })     
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/assignTeacherToStudent.js